'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import './index.scss';
import { BannerCom } from './BannerCom';
export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { list = [], size, autoPlay, tabLayout } = data;
    return (
        <GloLayout className={`editor-index-banner-swiper`} id={id} data={data}>
            <BannerCom
                className="index-banner-swiper2"
                prefixCls="index-banner-swiper"
                initIndex={initIndex}
                autoPlay={autoPlay}
                list={list}
                tabLayout={tabLayout}
                size={size}
            />
        </GloLayout>
    );
}
